export default __webpack_public_path__ + "static/real1-1357ba0a487ed8da1cc01091fc98064a.png";